import { Fragment, useEffect } from 'react';
import { useTheme } from '../ThemeContext';
import { SidebarIcon } from './SidebarIcon';
import { SidebarLogo } from './SidebarLogo';
import { SidebarMenu } from './SidebarMenu';

/** CUBA Sidebar shell — overlay + wrapper + icon/logo/menu */
export function Sidebar() {
  const { toggleIcon, setToggleIcon } = useTheme();

  useEffect(() => {
    const onScroll = () => {
      const main = document.querySelector('.sidebar-main');
      if (!main) return;
      if (window.scrollY > 400) main.className = 'sidebar-main hovered';
      else main.className = 'sidebar-main';
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeOverlay = () => {
    document.querySelector('.bg-overlay1')?.classList.remove('active');
    document.querySelector('.sidebar-links')?.classList.remove('active');
    if (window.innerWidth <= 991) setToggleIcon(true);
  };

  return (
    <Fragment>
      <div className="bg-overlay1" onClick={closeOverlay} />
      <div
        className={`sidebar-wrapper ${toggleIcon ? 'close_icon' : ''}`}
        sidebar-layout="stroke-svg"
      >
        <SidebarIcon />
        <SidebarLogo />
        <SidebarMenu onNavigate={closeOverlay} />
      </div>
    </Fragment>
  );
}
